module.exports = __webpack_public_path__ + "img/trailer01-45s-preview.b75a15af.jpg";